import type { Device } from './device.interface';

export interface DeviceTag {
    C_Device_key: string;
    Device: Device;
    Tag: string;
}
